import React, { Component } from 'react';

class Select extends Component {
	render() {

		return (
			<div className={"pp-input-wrapper pp-select-wrapper " + (this.props.required ? "pp-required" : '') +
			(this.props.error ? " pp-error" : "")}>
				<label
					className="pp-input-label"
					htmlFor={this.props.htmlID}
				>
					{this.props.label}
					{(this.props.required ? "*" : '')}
				</label>
				<select
					id={this.props.htmlID}
					name={this.props.htmlName}
					onChange={this.props.onChange}
					className="pp-select"
					disabled={this.props.disabled}
					value={this.props.value || ""}>
						<option value="">Select {this.props.placeholderText}</option>
						{this.props.options &&
							this.props.options.map(option => (
								<option value={option.value} key={option.value}>{option.text}</option>
							))
						}
				</select>
			</div>
		);
	}
}

export default Select;



// WEBPACK FOOTER //
// ./src/components/Select.js